const tooltipStyle = { position: "absolute", outlineStyle: "solid", outlineColor: "#ddd", outlineWidth: "1px", backgroundColor: "#000000", borderRadius: "1rem", zIndex: "9999" }

export { tooltipStyle };